import { toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-ec90db3a")

_pushScopeId("data-v-ec90db3a")
const _hoisted_1 = { class: "con group-container" }
const _hoisted_2 = {
  key: 0,
  class: "heading"
}
const _hoisted_3 = {
  key: 1,
  class: "description"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_ctx.heading)
      ? (_openBlock(), _createBlock("h3", _hoisted_2, _toDisplayString(_ctx.heading), 1))
      : _createCommentVNode("", true),
    (_ctx.description)
      ? (_openBlock(), _createBlock("div", _hoisted_3, _toDisplayString(_ctx.description), 1))
      : _createCommentVNode("", true),
    _renderSlot(_ctx.$slots, "default", {}, undefined, true)
  ]))
})